import React from "react"

// Wrapper for a product-marketing page.

type Props = {
  children: React.ReactNode
  style?: React.CSSProperties
}

const Layout = ({ children, style = {} }: Props) => (
  <div className="landing-page" style={style}>
    {children}
  </div>
)

export default Layout
